<allas-main-layout>
  <allas-margin-wrapper styleClass="fs-condensed mt-8 mb-16">
    <!-- Header fijo para que salga cuando el carrito esté lleno o vacío :D -->
    <div class="mb-6 sm:mb-3">
      <button
        (click)="goBack()"
        class="flex items-center gap-2 text-gray-800 hover:text-red-600 transition-colors cursor-pointer mb-2"
        aria-label="Continuar comprando"
        title="Continuar comprando"
      >
        <svg
          class="w-4 h-4 text-red-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          ></path>
        </svg>
        <span class="text-sm font-normal fs-condensed">
          CONTINUE COMPRANDO
        </span>
      </button>

      <h1 class="text-2xl sm:text-3xl text-gray-900 fs-condensed">
        MI <strong class="font-black">CARRITO</strong>
      </h1>
    </div>

    <!-- Banner de vehículo no seleccionado -->
    @if (!hasDefaultVehicle()) {
    <div class="mb-4 sm:mb-6">
      <!-- <div
                class="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4 sm:p-6 relative overflow-hidden"
              >
                <div class="absolute top-3 right-3 opacity-10">
                  <lucide-icon
                    [name]="sparklesIcon"
                    class="w-6 h-6 text-blue-400"
                  ></lucide-icon>
                </div>

                <div class="flex items-start space-x-3 sm:space-x-4">
                  <div class="flex-shrink-0">
                    <div
                      class="w-10 h-10 sm:w-12 sm:h-12 bg-appPrimary-500 rounded-full flex items-center justify-center"
                    >
                      <lucide-icon
                        [name]="carIcon"
                        class="w-5 h-5 sm:w-6 sm:h-6 text-white"
                      ></lucide-icon>
                    </div>
                  </div>

                  <div class="flex-1 min-w-0">
                    <div class="flex items-center space-x-2 mb-2">
                      <h3
                        class="text-sm sm:text-base font-semibold text-gray-900"
                      >
                        Mejora tu cotización
                      </h3>
                      <lucide-icon
                        [name]="zapIcon"
                        class="w-4 h-4 sm:w-5 sm:h-5 text-blue-500"
                      ></lucide-icon>
                    </div>

                    <p
                      class="text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4 leading-relaxed"
                    >
                      Selecciona tu vehículo para obtener cotizaciones más
                      precisas y
                      <span class="font-medium text-blue-600">
                        recomendaciones personalizadas
                      </span>
                    </p>

                    <div class="flex flex-col sm:flex-row gap-2 sm:gap-3">
                      <button
                        (click)="goToGarage()"
                        class="bg-appPrimary-500 hover:bg-blue-700 text-white px-4 sm:px-6 py-2 sm:py-2.5 rounded-lg font-medium transition-colors flex items-center justify-center space-x-2 text-xs sm:text-sm"
                      >
                        <lucide-icon
                          [name]="targetIcon"
                          class="w-3 h-3 sm:w-4 sm:h-4"
                        ></lucide-icon>
                        <span>Seleccionar Vehículo</span>
                      </button>

                      <button
                        (click)="addQuickVehicle()"
                        class="bg-white hover:bg-gray-50 text-gray-700 px-4 sm:px-6 py-2 sm:py-2.5 rounded-lg font-medium transition-colors border border-gray-300 hover:border-gray-400 flex items-center justify-center space-x-2 text-xs sm:text-sm"
                      >
                        <lucide-icon
                          [name]="plusIcon"
                          class="w-3 h-3 sm:w-4 sm:h-4"
                        ></lucide-icon>
                        <span>Agregar Nuevo</span>
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  class="mt-4 sm:mt-6 grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-4"
                >
                  <div
                    class="flex items-center space-x-2 text-xs sm:text-sm text-gray-500"
                  >
                    <lucide-icon
                      [name]="heartIcon"
                      class="w-3 h-3 sm:w-4 sm:h-4 text-red-400"
                    ></lucide-icon>
                    <span>Cotizaciones precisas</span>
                  </div>
                  <div
                    class="flex items-center space-x-2 text-xs sm:text-sm text-gray-500"
                  >
                    <lucide-icon
                      [name]="rocketIcon"
                      class="w-3 h-3 sm:w-4 sm:h-4 text-blue-400"
                    ></lucide-icon>
                    <span>Proceso más rápido</span>
                  </div>
                </div>
              </div> -->
    </div>
    }

    <!-- Banner de tienda no seleccionada -->
    @if (!hasDefaultStore() ) {
    <div class="mb-4 sm:mb-6">
      <div
        class="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-lg p-4 sm:p-6 relative overflow-hidden"
      >
        <!-- Elementos decorativos sutiles -->
        <div class="absolute top-3 right-3 opacity-10">
          <lucide-icon
            [name]="sparklesIcon"
            class="w-6 h-6 text-green-400"
          ></lucide-icon>
        </div>

        <div class="flex items-start space-x-3 sm:space-x-4">
          <div class="flex-shrink-0">
            <div
              class="w-10 h-10 sm:w-12 sm:h-12 bg-green-600 rounded-full flex items-center justify-center"
            >
              <lucide-icon
                [name]="mapPinIcon"
                class="w-5 h-5 sm:w-6 sm:h-6 text-white"
              ></lucide-icon>
            </div>
          </div>

          <div class="flex-1 min-w-0">
            <div class="flex items-center space-x-2 mb-2">
              <h3 class="text-sm sm:text-base font-semibold text-gray-900">
                Selecciona tu tienda
              </h3>
              <lucide-icon
                [name]="zapIcon"
                class="w-4 h-4 sm:w-5 sm:h-5 text-green-500"
              ></lucide-icon>
            </div>

            <p
              class="text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4 leading-relaxed"
            >
              Elige tu sucursal preferida para recibir
              <span class="font-medium text-green-600">
                atención personalizada
              </span>
              y conocer horarios específicos
            </p>

            <div class="flex flex-col sm:flex-row gap-2 sm:gap-3">
              <button
                (click)="goToStoreSelection()"
                class="bg-green-600 hover:bg-green-700 text-white px-4 sm:px-6 py-2 sm:py-2.5 rounded-lg font-medium transition-colors flex items-center justify-center space-x-2 text-xs sm:text-sm"
              >
                <lucide-icon
                  [name]="targetIcon"
                  class="w-3 h-3 sm:w-4 sm:h-4"
                ></lucide-icon>
                <span>Seleccionar Tienda</span>
              </button>

              <button
                (click)="goToFindStore()"
                class="bg-white hover:bg-gray-50 text-gray-700 px-4 sm:px-6 py-2 sm:py-2.5 rounded-lg font-medium transition-colors border border-gray-300 hover:border-gray-400 flex items-center justify-center space-x-2 text-xs sm:text-sm"
              >
                <lucide-icon
                  [name]="mapPinIcon"
                  class="w-3 h-3 sm:w-4 sm:h-4"
                ></lucide-icon>
                <span>Encontrar Tienda</span>
              </button>
            </div>
          </div>
        </div>

        <div
          class="mt-4 sm:mt-6 grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-4"
        >
          <div
            class="flex items-center space-x-2 text-xs sm:text-sm text-gray-500"
          >
            <lucide-icon
              [name]="heartIcon"
              class="w-3 h-3 sm:w-4 sm:h-4 text-red-400"
            ></lucide-icon>
            <span>Atención personalizada</span>
          </div>
          <div
            class="flex items-center space-x-2 text-xs sm:text-sm text-gray-500"
          >
            <lucide-icon
              [name]="rocketIcon"
              class="w-3 h-3 sm:w-4 sm:h-4 text-green-400"
            ></lucide-icon>
            <span>Horarios específicos</span>
          </div>
        </div>
      </div>
    </div>
    }

    <!-- Carrito vacío -->
    @if (!carrito() || cartService.cartItems().length === 0) { @if
    (savedForLaterItems().length === 0) {
    <!-- Carrito vacío SIN items guardados - Mostrar mensaje completo -->
    <div class="flex flex-col lg:flex-row gap-6">
      <!-- Mensaje de carrito vacío -->
      <div class="flex-1 bg-[#f3f4f6] py-8 px-5 xl:p-2 xl:px-4">
        <div class="sm:p-8 text-center">
          <div class="text-gray-400 mb-3 sm:mb-4">
            <img
              src="/images/carrito/shopping-car-icon.webp"
              alt="Carrito vacío"
              class="w-12 h-12 sm:w-16 sm:h-16 mx-auto"
            />
          </div>
          <h2
            class="text-lg sm:text-xl font-normal text-gray-900 mb-2 fs-condensed"
          >
            PARECE QUE TU CARRITO ESTÁ VACÍO
          </h2>
          <p class="text-xs sm:text-sm text-gray-600 mb-4 sm:mb-6">
            Agrega productos ahora
          </p>
          <div class="flex gap-2 sm:gap-3 justify-center">
            <a
              routerLink="/"
              class="bg-[#010101] hover:bg-[#272727] text-white px-3 sm:px-4 py-2 font-normal transition-colors text-xs sm:text-sm fs-condensed"
            >
              VOLVER A PÁGINA PRINCIPAL
            </a>
          </div>
        </div>
      </div>

      <!-- Checkout Summary - Arriba de recomendaciones en mobile, al lado en desktop -->
      <div class="w-full lg:w-80 flex-shrink-0">
        <div class="lg:sticky lg:top-4">
          <allas-checkout-summary
            [totalProducts]="cartService.totalItems()"
            [cartItems]="cartService.cartItems()"
          ></allas-checkout-summary>
        </div>
      </div>
    </div>

    <!-- Recomendaciones de productos vistos recientemente - Abajo del checkout en mobile -->
    <ng-container *ngTemplateOutlet="recomendaciones"></ng-container>
    } @else {
    <!-- Carrito vacío PERO con items guardados - Mostrar estructura con guardados -->
    <div class="flex flex-col lg:flex-row gap-6">
      <!-- Lista de productos guardados para más tarde -->
      <div class="flex-1">
        <div class="mb-4 bg-[#f3f4f6] py-4 px-5 rounded-lg">
          <p class="text-sm text-gray-600 text-center">
            Tu carrito está vacío. Revisa tus productos guardados abajo.
          </p>
        </div>

        <div class="mt-6">
          <h2 class="text-xl font-bold text-gray-900 mb-4 fs-condensed">
            GUARDADO PARA VER MÁS TARDE
          </h2>
          <div class="space-y-4">
            @for (item of savedForLaterItems(); track item.id) {
            <div class="bg-white border border-gray-200 p-4 rounded-lg">
              <!-- Header: Nombre del producto y botones de acción -->
              <div class="flex justify-between items-start mb-4">
                <h3 class="font-semibold text-gray-900 text-base flex-1 pr-2">
                  {{
                    smartTitle(
                      item.producto?.nombre_web || item.producto?.descripcion || item.grupo?.name || ""
                    )
                  }}
                </h3>

                <!-- Botones de acción -->
                <div class="flex items-center gap-3 flex-shrink-0">
                  <button
                    (click)="moveToCart(item)"
                    class="text-blue-600 hover:text-blue-800 text-sm underline font-medium"
                  >
                    Mover al Carrito
                  </button>
                  <button
                    (click)="removeSavedItem(item.id)"
                    class="text-gray-600 hover:text-gray-800 text-sm underline"
                  >
                    Borrar
                  </button>
                </div>
              </div>

              <!-- Layout principal: Imagen + Info + Precio -->
              <div class="flex gap-4 items-start">
                <!-- Imagen del producto -->
                <div class="flex-shrink-0">
                  <div class="w-16 h-16 bg-gray-50 rounded-lg overflow-hidden">
                    <img
                      [src]="imagenMostrar(item)"
                      class="w-full h-full object-cover"
                      alt="Producto"
                    />
                  </div>
                </div>

                <!-- Información del producto -->
                <div class="flex-1 min-w-0">
                  <!-- Part Number y SKU -->
                  <div class="mb-2">
                    @if (item.producto?.part_number) {
                    <p class="text-sm text-gray-600">
                      Parte #{{ item.producto?.part_number }}
                    </p>
                    } @if (item.producto?.sku) {
                    <p class="text-sm text-gray-600">
                      Código #{{ item.producto?.sku }}
                    </p>
                    }
                  </div>

                  <!-- Precio unitario -->
                  @if (item.producto) {
                  <div class="mb-2">
                    <span
                      class="inline-block bg-gray-100 text-gray-800 px-2 py-1 rounded text-sm font-medium"
                    >
                      L.
                      {{ precioMostrar(item.producto) | number : "1.2-2" }}
                      Unidad
                    </span>
                  </div>
                  }

                  <!-- Cantidad guardada -->
                  @if (item.cantidad > 1) {
                  <div>
                    <span class="text-sm text-gray-600">
                      Cantidad: {{ item.cantidad }}
                    </span>
                  </div>
                  }
                </div>
              </div>
            </div>
            }
          </div>
        </div>
      </div>

      <!-- Checkout Summary -->
      <div class="w-full lg:w-80 flex-shrink-0">
        <div class="lg:sticky lg:top-4">
          <allas-checkout-summary
            [totalProducts]="cartService.totalItems()"
            [cartItems]="cartService.cartItems()"
          ></allas-checkout-summary>
        </div>
      </div>
    </div>

    <!-- Recomendaciones de productos vistos recientemente -->
    <ng-container *ngTemplateOutlet="recomendaciones"></ng-container>
    } }

    <!-- Carrito no vacío -->
    @else {
    <div class="flex flex-col lg:flex-row gap-6">
      <!-- Lista de productos optimizada -->
      <div class="flex-1">
        <!-- Card de Recompensas -->
        <!-- <ng-container *ngTemplateOutlet="bannerRecompensas"></ng-container> -->

        <div class="space-y-4">
          @for (item of cartService.cartItems(); track item.id) {
          <div class="bg-white border border-gray-200 p-4 rounded-lg">
            <!-- Header: Nombre del producto y botones de acción -->
            <div class="flex justify-between items-start mb-4">
              <h3 class="font-semibold text-gray-900 text-base flex-1 pr-2">
                {{
                  smartTitle(
                    item.producto?.nombre_web || item.producto?.descripcion || item.grupo?.name || ""
                  )
                }}
              </h3>

              <!-- Botones de acción -->
              <div class="flex items-center gap-3 flex-shrink-0">
                <button
                  (click)="saveForLater(item)"
                  class="text-gray-600 hover:text-gray-800 text-sm underline"
                >
                  Guardar para más Tarde
                </button>
                <button
                  (click)="removeItem(item)"
                  class="text-gray-600 hover:text-gray-800 text-sm underline"
                >
                  Borrar
                </button>
              </div>
            </div>

            <!-- Layout principal: Imagen + Info + Precio + Cantidad -->
            <div class="flex gap-4 items-start mb-4">
              <!-- Imagen del producto -->
              <div class="flex-shrink-0">
                <div class="w-16 h-16 bg-gray-50 rounded-lg overflow-hidden">
                  <img
                    [src]="imagenMostrar(item)"
                    class="w-full h-full object-cover"
                    alt="Producto"
                  />
                </div>
              </div>

              <!-- Información del producto -->
              <div class="flex-1 min-w-0">
                <!-- Part Number y SKU -->
                <div class="mb-2">
                  @if (item.producto?.part_number) {
                  <p class="text-sm text-gray-600">
                    Parte #{{ item.producto?.part_number }}
                  </p>
                  } @if (item.producto?.sku) {
                  <p class="text-sm text-gray-600">
                    Código #{{ item.producto?.sku }}
                  </p>
                  }
                </div>

                <!-- Precio unitario -->
                @if (item.producto) {
                <div class="mb-2">
                  <span
                    class="inline-block bg-blue-100 text-blue-800 px-2 py-1 rounded text-sm font-medium"
                  >
                    L. {{ precioMostrar(item.producto) | number : "1.2-2" }} Unidad
                  </span>
                </div>
                }

                @if (item.alertas?.length) {
                <div class="mb-2 space-y-1">
                  @for (alerta of item.alertas; track $index) {
                  <div
                    class="text-xs font-medium rounded px-2 py-1 border"
                    [class.bg-amber-50]="isWarningAlerta(alerta)"
                    [class.text-amber-800]="isWarningAlerta(alerta)"
                    [class.border-amber-200]="isWarningAlerta(alerta)"
                    [class.bg-emerald-50]="!isWarningAlerta(alerta)"
                    [class.text-emerald-800]="!isWarningAlerta(alerta)"
                    [class.border-emerald-200]="!isWarningAlerta(alerta)"
                  >
                    {{ alertaDisplayMessage(alerta) }}
                  </div>
                  }
                </div>
                }

                @if (availabilityLabel(item); as stockLabel) {
                <p
                  class="text-sm font-semibold mb-1"
                  [class.text-amber-700]="isOutOfStock(item)"
                  [class.text-emerald-700]="!isOutOfStock(item)"
                >
                  {{ stockLabel }}
                </p>
                } @else if (!getResolvedSucursalId()) {
                <p class="text-sm text-amber-700 mb-1">
                  Sin una tienda preferida, no se puede garantizar el inventario
                </p>
                }
              </div>

              <!-- Precio total y controles de cantidad -->
              <div class="flex flex-col items-end gap-2 flex-shrink-0">
                <!-- Precio total -->
                @if (item.producto) {
                <div class="text-right">
                  <p class="text-lg font-bold text-gray-900">
                    L.
                    <span
                      [innerHTML]="
                        formatPrice(precioMostrar(item.producto) * item.cantidad)
                      "
                    ></span>
                  </p>
                </div>
                }

                <!-- Controles de cantidad -->
                <div class="flex items-center gap-2">
                  <button
                    (click)="decreaseQuantity(item)"
                    class="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
                    [disabled]="item.cantidad <= 1"
                  >
                    <lucide-icon
                      [name]="minusIcon"
                      class="w-4 h-4"
                    ></lucide-icon>
                  </button>
                  <span class="w-8 text-center font-medium">{{
                    item.cantidad
                  }}</span>
                  <button
                    (click)="increaseQuantity(item)"
                    class="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
                    [disabled]="!canIncreaseQuantity(item)"
                  >
                    <lucide-icon
                      [name]="plusIcon"
                      class="w-4 h-4"
                    ></lucide-icon>
                  </button>
                </div>
              </div>
            </div>

            <!-- Opciones de entrega -->
            <div class="mb-4">
              <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
                @for (option of deliveryOptions; track option.value) {
                <button
                  (click)="selectDeliveryOption(item, option.value)"
                  [class]="
                    getDeliveryButtonClasses(
                      item.selectedDelivery === option.value
                    )
                  "
                  class="p-3 rounded-lg border text-center transition-all duration-200 hover:shadow-md relative"
                >
                  <!-- Checkmark para opción seleccionada -->
                  @if (item.selectedDelivery === option.value) {
                  <div
                    class="absolute top-2 left-2 w-4 h-4 bg-red-600 rounded-full flex items-center justify-center"
                  >
                    <span class="text-white text-xs font-bold">✓</span>
                  </div>
                  }

                  <!-- Contenido del botón -->
                  <div class="relative">
                    <div class="text-sm font-bold text-gray-900 mb-1">
                      {{ option.label }}
                    </div>
                    <div
                      class="text-xs font-medium text-gray-900 mb-2"
                      [innerHTML]="getFormattedDescription(option.description)"
                    ></div>
                    <div class="text-xs font-bold text-gray-900">
                      {{ option.price }}
                    </div>
                  </div>
                </button>
                }
              </div>

              <!-- Texto de tienda seleccionada -->
              @if (item.selectedDelivery === 'pickup' && getSelectedStore()) {
              <div class="flex items-center gap-2 mt-3">
                <span class="text-red-600 text-xs font-bold">✓</span>
                <span class="text-red-600 font-bold text-sm"> Traer en </span>
                <span class="text-gray-600 text-sm underline">
                  {{ getSelectedStore() }}
                </span>
              </div>
              }
            </div>

            <!-- Vehículo seleccionado -->
            @if (hasDefaultVehicle()) {
            <div class="flex items-center gap-2 text-blue-600 text-sm">
              <lucide-icon [name]="carIcon" class="w-4 h-4"></lucide-icon>
              <span>{{ getVehicleText() }}</span>
            </div>
            }
          </div>
          }
        </div>

        <!-- Lista de productos guardados para más tarde -->
        @if (savedForLaterItems().length > 0) {
        <div class="mt-8">
          <h2 class="text-xl font-bold text-gray-900 mb-4 fs-condensed">
            GUARDADO PARA VER MÁS TARDE
          </h2>
          <div class="space-y-4">
            @for (item of savedForLaterItems(); track item.id) {
            <div class="bg-white border border-gray-200 p-4 rounded-lg">
              <!-- Header: Nombre del producto y botones de acción -->
              <div class="flex justify-between items-start mb-4">
                <h3 class="font-semibold text-gray-900 text-base flex-1 pr-2">
                  {{
                    smartTitle(
                      item.producto?.nombre_web || item.producto?.descripcion || item.grupo?.name || ""
                    )
                  }}
                </h3>

                <!-- Botones de acción -->
                <div class="flex items-center gap-3 flex-shrink-0">
                  <button
                    (click)="moveToCart(item)"
                    class="text-allasRed hover:text-allasRed/75 text-sm underline font-medium"
                  >
                    Mover al Carrito
                  </button>
                  <button
                    (click)="removeSavedItem(item.id)"
                    class="text-gray-600 hover:text-gray-800 text-sm underline"
                  >
                    Borrar
                  </button>
                </div>
              </div>

              <!-- Layout principal: Imagen + Info + Precio -->
              <div class="flex gap-4 items-start">
                <!-- Imagen del producto -->
                <div class="flex-shrink-0">
                  <div class="w-16 h-16 bg-gray-50 rounded-lg overflow-hidden">
                    <img
                      [src]="imagenMostrar(item)"
                      class="w-full h-full object-cover"
                      alt="Producto"
                    />
                  </div>
                </div>

                <!-- Información del producto -->
                <div class="flex-1 min-w-0">
                  <!-- Part Number y SKU -->
                  <div class="mb-2">
                    @if (item.producto?.part_number) {
                    <p class="text-sm text-gray-600">
                      Parte #{{ item.producto?.part_number }}
                    </p>
                    } @if (item.producto?.sku) {
                    <p class="text-sm text-gray-600">
                      Código #{{ item.producto?.sku }}
                    </p>
                    }
                  </div>

                  <!-- Precio unitario -->
                  <div class="mb-2">
                    @if (item.producto) {
                    <span
                      class="inline-block bg-gray-100 text-gray-800 px-2 py-1 rounded text-sm font-medium"
                    >
                      L.
                      {{ precioMostrar(item.producto) | number : "1.2-2" }} Unidad
                    </span>
                    }
                  </div>

                  <!-- Cantidad guardada -->
                  @if (item.cantidad > 1) {
                  <div>
                    <span class="text-sm text-gray-600">
                      Cantidad: {{ item.cantidad }}
                    </span>
                  </div>
                  }
                </div>
              </div>
            </div>
            }
          </div>
        </div>
        }
      </div>
      <!-- Checkout Summary - Arriba de recomendaciones en mobile, al lado en desktop -->
      <div class="w-full lg:w-80 flex-shrink-0">
        <div class="lg:sticky lg:top-4">
          <allas-checkout-summary
            [totalProducts]="cartService.totalItems()"
            [cartItems]="cartService.cartItems()"
            (requestWhatsAppQuote)="requestWhatsAppQuote($event)"
          ></allas-checkout-summary>
        </div>
      </div>
    </div>

    <!-- Recomendaciones de productos vistos recientemente - Abajo del checkout en mobile -->
    <ng-container *ngTemplateOutlet="recomendaciones"></ng-container>
    }
  </allas-margin-wrapper>
</allas-main-layout>

<ng-template #recomendaciones>
  <!-- Recomendaciones de productos vistos recientemente -->
  @if (productosVistosRecientemente.length > 0) {
  <div class="mt-8">
    <allas-product-cards
      [productos]="productosVistosRecientemente"
      title="RECOMENDADO PARA TÍ"
      (addToCart)="onAddToCartFromRecommendations($event)"
    ></allas-product-cards>
  </div>
  }
</ng-template>

<ng-template #bannerRecompensas>
  <div class="bg-white rounded-lg border border-gray-200 p-4 mb-4 shadow-sm">
    <div class="flex items-center justify-between">
      <!-- Imagen de recompensas -->
      <div class="flex-shrink-0">
        <img
          src="/images/carrito/banner-recompensas.webp"
          alt="Recompensas"
          class="h-16 w-auto"
          onerror="this.style.display='none'"
        />
      </div>

      <!-- Espacio entre imagen y botón -->
      <div class="flex-1"></div>

      <!-- Botón de seleccionar recompensa -->
      <button
        class="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-thin fs-condensed transition-colors duration-200"
      >
        SELECCIONAR RECOMPENSA
      </button>

      <!-- Separador vertical -->
      <div class="w-px h-8 bg-gray-300 mx-4"></div>

      <!-- Texto de recompensas -->
      <div class="text-right">
        <span class="text-gray-900">Recompensas </span>
        <span class="font-bold text-gray-900">L.28,000.0</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #bannerVehiculoSeleccionado>
  <button
    class="flex items-center py-4 gap-2 text-[#003f87] font-bold text-sm hover:opacity-80 transition-opacity"
  >
    <img
      src="/images/carrito/front-car-blue.webp"
      alt="Vehículo"
      class="w-6 h-5"
      onerror="this.style.display='none'"
    />
    <div class="flex flex-col">
      <span>{{ getVehicleText() }}</span>
      <div class="h-0.5 bg-[#003f87] mt-1"></div>
    </div>
  </button>
</ng-template>
